export default class Searched {
    static handleChange;
    static hidePopularTransports;
    static value = '';
}